/**
 * Tamaño de tipografía base (preferencia accesibilidad).
 * - "100" = 16px (default, Tailwind base).
 * - "112" = 18px (A+) — más legible para usuarios 60+.
 * - "125" = 20px (A++) — alta legibilidad / baja visión.
 *
 * Se aplica seteando `document.documentElement.style.fontSize`. Como
 * Tailwind usa unidades `rem`, cambiar el font-size del `<html>`
 * escala proporcionalmente todo el UI sin tocar clases.
 *
 * El bootstrap síncrono vive en `index.html` para evitar saltos de
 * tipografía al hidratar React.
 *
 * Nota: el módulo se llama `theme.ts` por historia (antes manejaba
 * dark/light mode también). El admin no expone dark mode — la base de
 * usuarios SSR es 60+ y prefiere tono claro.
 */

export type FontScale = "100" | "112" | "125";

const FONT_SCALE_KEY = "innovasuite.fontScale";

const FONT_SCALE_PX: Record<FontScale, number> = {
  "100": 16,
  "112": 18,
  "125": 20,
};

export function getFontScale(): FontScale {
  try {
    const v = localStorage.getItem(FONT_SCALE_KEY);
    if (v === "100" || v === "112" || v === "125") return v;
  } catch {
    // ignore
  }
  return "100";
}

export function setFontScale(scale: FontScale): void {
  try {
    localStorage.setItem(FONT_SCALE_KEY, scale);
  } catch {
    // ignore
  }
  applyFontScale(scale);
}

export function applyFontScale(scale: FontScale): void {
  const px = FONT_SCALE_PX[scale];
  document.documentElement.style.fontSize = `${px}px`;
}

export function applyFontScaleFromStorage(): void {
  applyFontScale(getFontScale());
}
